export default function formatMillionCurrency(
  value: number,
  short: boolean = false
): string {
  const singular = short ? 'Mio.' : 'Million';
  const plural = short ? 'Mio.' : 'Millionen';
  const million = value !== 1 ? plural : singular;
  return `${value} ${million} €`;
}
